export default "__VITE_ASSET__BDbb$u5U__"